// i18n area 'tasks' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.nl-NL.meta.json.
import type { enUS } from './tasks'

export const nlNL: typeof enUS = {
  macrotasks: {
    title: 'Macrotasks',
    subtitle: 'Samengestelde bewerkingen — te hervatten vanaf de mislukte stap, of af te breken',
    colType: 'Type',
    colTarget: 'Doel',
    colPhase: 'Fase',
    colSteps: 'Stappen',
    empty: 'Geen macrotasks',
    detail: 'Details',
    failedAt: 'mislukt bij',
    resume: 'Opnieuw proberen vanaf de mislukte stap',
    abort: 'Alles afbreken',
    cancel: 'Annuleren',
    actionError: 'De actie is geweigerd'
  },
  tasks: {
    title: 'Tasks',
    searchPlaceholder: 'Zoek op type of doel',
    type: 'Type',
    target: 'Doel',
    phaseLabel: 'Fase',
    progress: 'Voortgang',
    started: 'Gestart',
    finished: 'Beëindigd',
    node: 'Node',
    empty: 'Geen tasks',
    loadError: 'De tasks konden niet worden geladen — is de TVirt-backend bereikbaar?',
    limboHint: "Node '{node}' onbereikbaar sinds {time} — de task houdt de write lease op zijn doel vast totdat de node terugkomt of als uitgeschakeld wordt bevestigd",
    nodeAttested: 'Node bevestigd uitgeschakeld',
    phase: {
      queued: 'In wachtrij',
      running: 'Wordt uitgevoerd',
      succeeded: 'Voltooid',
      failed: 'Mislukt',
      cancelled: 'Geannuleerd',
      'failed-at-step': 'Mislukt bij een stap',
      aborted: 'Afgebroken'
    },
    dropdown: {
      tooltip: 'Lopende tasks',
      title: 'Lopende tasks',
      empty: 'Geen lopende tasks',
      viewAll: 'Alle tasks bekijken'
    },
    detail: {
      open: 'Details',
      scope: 'Scope',
      message: 'Bericht',
      params: 'Parameters',
      result: 'Resultaat',
      errorTitle: 'Fout',
      steps: 'Stappen',
      failedAt: 'mislukt bij',
      superseded: 'achterhaald',

      // Dialog standard (round #156): de plek van het kind in het plan van de
      // ouder, de oudertask zelf (in-place te openen) en de schuldige stap.
      step: 'Stap',
      parent: 'Bovenliggende task',
      failedStep: 'Mislukte stap',
      log: 'Log',
      logEmpty: 'Nog geen logregels',
      close: 'Sluiten'
    },
    actions: {
      cancel: 'Annuleren',
      resume: 'Opnieuw proberen vanaf de mislukte stap',
      abort: 'Alles afbreken (voltooide stappen terugdraaien)',
      refused: 'De actie is geweigerd'
    }
  },
  events: {
    loadError: 'Kon het journaal niet laden — is de TVirt-backend bereikbaar?',
    title: 'Gebeurtenissen',
    subtitle: 'Het historische geheugen van het cluster: voldongen feiten, nieuwste eerst',
    filterSeverity: 'Ernst',
    filterCategory: 'Categorie',
    filterAll: 'Alle',
    searchLabel: 'Zoeken',
    searchPlaceholder: 'Zoek in het hele journaal',
    subjectFilter: 'Gebeurtenissen van {subject} — toon alles',
    colAt: 'Wanneer',
    colSeverity: 'Ernst',
    colType: 'Type',
    colSubject: 'Onderwerp',
    colActor: 'Wie',
    colNode: 'Node',
    colMessage: 'Bericht',
    empty: 'Geen gebeurtenissen',
    loadMore: 'Meer laden',
    actorSystem: 'systeem',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Gebeurtenis-ID',
    taskCollectedHint: 'De task heeft een kortere bewaartermijn: eenmaal opgeruimd antwoordt de link niet meer',
    severity: {
      info: 'Info',
      warning: 'Waarschuwing',
      error: 'Fout',
      critical: 'Kritiek'
    },
    category: {
      lifecycle: 'Levenscyclus',
      config: 'Configuratie',
      availability: 'Beschikbaarheid',
      security: 'Beveiliging'
    },
    type: {
      haNetsvcFailedOver: 'Failover van de netwerkdienst',
      haNetsvcNoCandidate: 'Netwerkdienst zonder kandidaat-node',
      haNetsvcReaped: 'Lokale instantie gemaaid bij terugkeer',
      netsvcFloatipMoved: 'Zwevend IP verhuisd naar een andere houder',
      netsvcFloatipNoHolder: 'Zwevend IP zonder gezond doel',
      haAppFailedOver: 'Failover van App-instantie',
      haAppNoCandidate: 'App-instantie zonder kandidaatnode',
      haAppStorageLocalSkip: 'App-instantie niet overgenomen: persistente data lokaal op de dode node',
      haAppReaped: 'Lokale pod van App-instantie geoogst bij terugkeer'
    }
  },
  audit: {
    loadError: 'Kon het auditregister niet laden — is de TVirt-backend bereikbaar?',
    title: 'Audit',
    subtitle: 'Wie deed wat, wanneer, op welk object — gepoogde handelingen, weigeringen inbegrepen',
    filterOutcome: 'Uitkomst',
    filterAll: 'Alle',
    filterSudo: 'Alleen verhoogde handelingen',
    colAt: 'Wanneer',
    colActor: 'Wie',
    colAction: 'Actie',
    colTarget: 'Object',
    colOutcome: 'Uitkomst',
    colNode: 'Node',
    empty: 'Geen handelingen vastgelegd',
    loadMore: 'Meer laden',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Route',
    detailProblem: 'Reden',
    detailTask: 'Task',
    detailClientIp: 'Vanaf',
    detailId: 'Record-ID',
    detailSession: 'Sessie',
    taskHint: 'De uitkomst van een aanvaarde handeling leeft in het gebeurtenissenjournaal, onder ditzelfde task-id',
    outcome: {
      succeeded: 'Gelukt',
      accepted: 'Aanvaard',
      denied: 'Geweigerd',
      rejected: 'Afgewezen',
      failed: 'Mislukt'
    }
  },
  notifications: {
    loadError: 'Kon de meldingen niet laden — is de TVirt-backend bereikbaar?',
    actionError: 'De actie is geweigerd',
    title: 'Meldingen',
    subtitle: 'De bestemmingen waarheen de feiten van het journaal het cluster verlaten',
    rulesTitle: 'Regels',
    rulesSubtitle: 'Welke feiten vertrekken, en waarheen',
    deliveriesTitle: 'Afleveringen',
    deliveriesSubtitle: 'De uitkomst van elke melding, met het waarom als ze mislukt',
    colName: 'Naam',
    colKind: 'Type',
    colWhere: 'Waarheen',
    colScope: 'Scope',
    colSeverity: 'Ernst',
    colMatch: 'Filter',
    colTargets: 'Bestemming',
    colAt: 'Wanneer',
    colState: 'Status',
    colEvent: 'Gebeurtenis',
    colAttempts: 'Pogingen',
    colOutcome: 'Uitkomst',
    empty: 'Geen rij',
    matchAll: 'alle feiten',
    test: 'Testen',
    testOk: 'Testmelding afgeleverd bij {target}',
    testFailed: 'Test naar {target} mislukt: {reason}',
    retry: 'Opnieuw in de wachtrij',
    retried: 'Aflevering opnieuw in de wachtrij',
    grouped: 'en {count} andere herhalingen',
    state: {
      failed: 'Mislukt',
      pending: 'In wachtrij',
      sending: 'Wordt verzonden',
      sent: 'Verzonden'
    },
    tabTargets: 'Bestemmingen',
    tabRules: 'Regels',
    tabDeliveries: 'Afleveringen',
    targetCreateTitle: 'Nieuwe bestemming',
    ruleCreateTitle: 'Nieuwe regel',
    nameHint: 'Kleine letters, cijfers en streepjes; uniek per scope',
    kindImmutableHint: 'Onveranderlijk: het type wijzigen betekent een andere bestemming maken',
    kindSmtp: 'E-mail (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Status',
    enabledOn: 'Actief',
    enabledOff: 'Opgeschort',
    smtpHost: 'SMTP-server',
    smtpPort: 'Poort',
    smtpPortHint: 'Gebruikelijk: 25 zonder TLS, 587 met starttls, 465 met tls',
    smtpSecurity: 'Beveiliging',
    smtpFrom: 'Afzender',
    smtpTo: 'Ontvangers',
    smtpToHint: "Een of meer adressen, gescheiden door komma's",
    webhookUrl: 'URL',
    payload: 'Inhoud',
    payloadHint: 'Met minimal verlaten het bericht en de gegevens van de gebeurtenis het cluster niet',
    credential: 'Credential',
    credentialNone: 'Geen',
    credentialHintSmtp: 'Het relay-account uit de keystore; geen betekent anonieme SMTP',
    credentialHintWebhook: 'Het ondertekeningsgeheim uit de keystore; zonder ondertekening kan iedereen die de URL kent zich voordoen als het cluster',
    minSeverityHint: 'Een drempel, geen verzameling: vanaf deze ernst',
    categories: 'Categorieën',
    categoriesHint: 'Leeg = alle',
    types: 'Gebeurtenistypen',
    typesHint: "Gescheiden door komma's; leeg = alle. Een onbekend type wordt geweigerd",
    targetsHint: 'Ten minste één; ze moeten in de scope van de regel of een voorouder leven',
    recursiveOn: 'Ook de kind-scopes',
    recursiveOff: 'Alleen deze scope',
    recursiveHint: 'Resources leven in de bladeren: zonder kinderen meldt een regel op de wortel bijna niets',
    repeatWindow: 'Groeperingsvenster (s)',
    repeatWindowHint: 'Binnen het venster sturen herhalingen geen mail: ze worden op de eerste geteld. 0 schakelt uit',
    targetInUseError: 'Bestemming {name} wordt nog gebruikt door een regel'
  }
}
